const DeliveryAddressIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M12 2l7 5v5c0 5-3.5 9-7 10-3.5-1-7-5-7-10V7l7-5z'
      stroke='currentColor'
      strokeWidth='1.4'
      fill='none'
    />
  </svg>
);

export default DeliveryAddressIcon;
